import { useDimensionsContext } from "@ui/hooks/contexts/useDimensionsContext";
import { Dimensions } from "@ui/types/Dimensions";

export function useDocumentBodyDimensions(): Dimensions {
  const { documentBodyDimensions } = useDimensionsContext();
  return documentBodyDimensions;
}
